export default {
  'pages.trafficstars.loadFailed': 'Failed to load',
  'pages.trafficstars.saveSuccess': 'Saved successfully',
  'pages.trafficstars.saveFailed': 'Failed to save',
  'pages.trafficstars.editTitle': 'Edit TrafficStars S2S',
  'pages.trafficstars.createTitle': 'Create TrafficStars S2S',
  'pages.trafficstars.back': 'Back to list',
  'pages.trafficstars.loadError':
    'Unable to load. Refresh the page and try again.',
  'pages.trafficstars.name': 'Configuration name',
  'pages.trafficstars.nameRequired': 'Enter a configuration name',
  'pages.trafficstars.namePlaceholder':
    'e.g. Sports landing page button clicks',
  'pages.trafficstars.landingPage': 'Linked landing page',
  'pages.trafficstars.pageRequired': 'Select a landing page',
  'pages.trafficstars.pagePlaceholder': 'Select a standard or AI landing page',
  'pages.trafficstars.standardPage': 'Standard',
  'pages.trafficstars.key': 'Postback key',
  'pages.trafficstars.keyRequired': 'Enter the postback key',
  'pages.trafficstars.keyEditHelp':
    'The stored key is hidden. Leave blank to keep it.',
  'pages.trafficstars.keyHelp':
    'Copy the key from the S2S postback configuration generated in TrafficStars and enter it here.',
  'pages.trafficstars.keyEditPlaceholder':
    'Leave blank to keep the current key',
  'pages.trafficstars.keyPlaceholder': 'Enter the key value, not the full URL',
  'pages.trafficstars.goalOptional': 'Goal ID (goalid, optional)',
  'pages.trafficstars.goalInvalid': 'Goal ID must contain digits only',
  'pages.trafficstars.goalPlaceholder': 'e.g. 5714',
  'pages.trafficstars.valueOptional': 'Conversion revenue (value, optional)',
  'pages.trafficstars.priceOptional': 'Conversion cost (price, optional)',
  'pages.trafficstars.amountPlaceholder': 'e.g. 0.50',
  'pages.trafficstars.amountHelp':
    'Sent with each postback. Leave blank to omit.',
  'pages.trafficstars.amountInvalid':
    'Enter a number greater than or equal to 0',
  'pages.trafficstars.error.invalidValue':
    'Value must be a number greater than or equal to 0, not a placeholder',
  'pages.trafficstars.error.invalidPrice':
    'Price must be a number greater than or equal to 0, not a placeholder',
  'pages.trafficstars.remark': 'Notes',
  'pages.trafficstars.active': 'Enable postbacks',
  'pages.trafficstars.allowDuplicates': 'Allow duplicates',
  'pages.trafficstars.save': 'Save configuration',
  'pages.trafficstars.requestSuccess': 'Postback request succeeded',
  'pages.trafficstars.retryStillFailed':
    'The postback still failed. Check the response details.',
  'pages.trafficstars.retryFailed': 'Retry failed',
  'pages.trafficstars.time': 'Time',
  'pages.trafficstars.goalId': 'Goal ID',
  'pages.trafficstars.defaultLead': 'Default Lead',
  'pages.trafficstars.button': 'Button',
  'pages.trafficstars.status': 'Status',
  'pages.trafficstars.success': 'Request succeeded',
  'pages.trafficstars.failed': 'Failed',
  'pages.trafficstars.pending': 'Processing',
  'pages.trafficstars.attempts': 'Attempts',
  'pages.trafficstars.actions': 'Actions',
  'pages.trafficstars.details': 'Details',
  'pages.trafficstars.retryTitle': 'Retry this postback?',
  'pages.trafficstars.retryHelp':
    'Retry with the original Click ID and lead_code. TrafficStars decides whether to count duplicates. Wait one minute before retrying a processing record.',
  'pages.trafficstars.retry': 'Retry',
  'pages.trafficstars.statsTitle': 'TrafficStars postback logs',
  'pages.trafficstars.attributionHelp':
    'Request succeeded means the API returned a successful response. Confirm attribution in TrafficStars reporting and S2S Test.',
  'pages.trafficstars.allStatuses': 'All statuses',
  'pages.trafficstars.detailTitle': 'Postback details',
  'pages.trafficstars.pageUrl': 'Landing page',
  'pages.trafficstars.response': 'Response / error',
  'pages.trafficstars.emptyResponse': 'No response body',
  'pages.trafficstars.identifier': 'Identifier',
  'pages.trafficstars.buttonClick': 'Button clicks',
  'pages.trafficstars.listSubtitle':
    'Track landing page button clicks and send conversions to TrafficStars',
  'pages.trafficstars.listHeader': 'Postback configurations',
  'pages.trafficstars.copyFailed': 'Copy failed',
  'pages.trafficstars.error.notFound':
    'Configuration not found or access denied',
  'pages.trafficstars.error.invalidKey': 'Enter a valid postback key',
  'pages.trafficstars.error.missingKey': 'Enter the TrafficStars postback key',
  'pages.trafficstars.error.invalidGoal':
    'Use the numeric goal ID from TrafficStars, not a placeholder',
  'pages.trafficstars.error.inactive': 'This configuration is disabled',
  'pages.trafficstars.error.recordMissing': 'Postback record not found',
  'pages.trafficstars.error.notRetryable':
    'This record has succeeded or is still processing',
};
